import routerOptions0 from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.1_rollup@4.40.2_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}